module.exports = __webpack_public_path__ + "img/select.1dd29dab.svg";